/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// FOXKIT-CUSTOM

document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    const incarts = document.querySelectorAll("foxkit-incart-upsell");
    for (const incart of incarts) {
      setTimeout(() => {
        incart.renderComponent();
      }, 500);
    }
  }, 1000);
});

window.FoxKitAddToCart = async (payload) => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );

  setTimeout(() => {
    const incarts = document.querySelectorAll("foxkit-incart-upsell");
    for (const incart of incarts) {
      incart.renderComponent();
    }
  }, 500);
};
// END FOXKIT-CUSTOM

$(window).scroll(function () {
  if ($(".multi_collection_template")) {
    var bar_distance =
      $(".collection_list_bar").outerHeight(true) +
      $("#shopify-section-header").outerHeight(true);
    if ($(this).scrollTop() > bar_distance) {
      $(".multi_collection_template").addClass("sticky_collection_bar");
    } else {
      $(".multi_collection_template").removeClass("sticky_collection_bar");
    }
  }
});

$(document).on("click", ".js_collection", function () {
  var data_id = $(this).attr("data_id");
  if ($(".collection_product_block#" + data_id).length) {
    var top_scroll =
      $(".collection_list_bar").outerHeight(true) +
      $("#shopify-section-header").outerHeight(true) +
      20;
    var target_offset =
      $(".collection_product_block#" + data_id).offset().top - top_scroll;
    $("html, body").stop().animate({ scrollTop: target_offset }, 2000);
  }
});

$(document).ready(function () {
  if ($(".collection_product_block").length) {
    var menuItems = $(".CollectionInner").find(".collection_product_block"),
      scrollItems = menuItems.map(function () {
        var item = $(this);
        if (item.length) {
          return item;
        }
      });

    $(window).scroll(function () {
      var fromTop =
        $(this).scrollTop() +
        $("#shopify-section-header").outerHeight(true) +
        $(".collection_list_bar").outerHeight(true) +
        50;
      var cur = scrollItems.map(function () {
        if ($(this).offset().top < fromTop) return this;
      });
      cur = cur[cur.length - 1];
      var id = cur && cur.length ? cur[0].id : "";

      if (cur != undefined) {
        var current_element = cur[0].id;
        if ($(".collection_block[data_id='" + current_element + "']").length) {
          $(".collection_block").removeClass("active");
          $(".collection_block[data_id='" + current_element + "']").addClass(
            "active"
          );

          var $active = $(
            ".collection_block[data_id='" + current_element + "']"
          );
          var scroll_pos;
          if ($active.hasClass("active")) {
            scroll_pos =
              $active.offset().left +
              $active.outerWidth(true) / 2 +
              $(".collection_bar").scrollLeft() -
              $(".collection_bar").width() / 2;
            $(".collection_bar").scrollLeft(scroll_pos);
          }
        }
      }
    });
  }
});

function closePopup() {
  $("body").removeClass("popup-active");
  $(".popup_target").removeClass("active");
  document.dispatchEvent(new CustomEvent("popup:close"));
}

$(document).on("click",".btn_target",function(){
  var $target = $(".popup_target[data='"+$(this).attr("data-target")+"']");
  $("body").addClass("popup-active");
  if($(this).parents(".popup_target").length) $(this).parents(".popup_target").removeClass("active");
  if($target.length) $target.addClass("active");
  if($(this).attr("data-target") === "login" && $(this).hasClass("membership_login")) {
    $target.find("form#customer_login").append("<input type='hidden' name='return_url' value='"+location.pathname+"' />");
  }
  document.dispatchEvent(new CustomEvent("popup:open"));
});

$(document).on("click",".popup-overlay",function(e){
  if($(e.target).is(".popup-overlay")) {
    if($(this).attr("data") === "login") $("form#customer_login input[name='return_url']").remove();
    closePopup(); 
  }
});

$(document).on("click",".popup-close",function(e){
  if($(this).parents(".popup-overlay").attr("data") === "login") $("form#customer_login input[name='return_url']").remove();
  closePopup();
});

$(".btn_addMember").on("click", function(){
const newform = $(this).parents('form')[0];
const newformData = new FormData(newform);
//   console.log('callll', newformData)
// return false;
  var $this = $(this);
  var items = JSON.parse($(this).attr("data"));

  let properties = {};

  if ($('.single_features:has(.qty_btn.minus:not(.stop_click))').length) {

    let properties = {};

    $('.single_features:has(.qty_btn.minus:not(.stop_click))').each(function () {
      const name = $(this).find('.title_text').text().trim();
      const value = $(this).find('.qty_value').text().trim();

      if (name && value) {
        properties[name] = value;
      }
    });

    if (items.length > 0) {
      items[0] = {
        ...items[0],
        properties: {
          ...(items[0].properties || {}),
          ...properties
        }
      };
    }
  }


  if(!items) return;

$('.ProductForm__AddToCart').attr('disabled', 'disabled')
  $this.attr("disabled", true);
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({items})
  })
  .then(response => {
    if(response.ok) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      document.querySelector("section.Product").dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: items[0]['id'],
          quantity: 1
        }
      }));
      if($this.parents(".popup-overlay").length) {
        $this.parents(".popup-overlay").removeClass("active");
        $("body").removeClass("popup-active");
      }
      if($this.parents('.upsell-btn')){
        $('.cus-membership').hide();
        $('.icon-text-image').hide();
        $('.ambassador_text').show();
        $('.pop-up-text').hide();

    }
    if(document.querySelector('.Product__Info  .ProductForm__BuyButtons .ProductForm__AddToCart.sticky_add_atc_btn')){
      document.querySelector('.Product__Info  .ProductForm__BuyButtons .ProductForm__AddToCart').classList.remove('sticky_add_atc_btn');
    }
    }else{
      if(document.querySelector('.Product__Info  .ProductForm__BuyButtons .ProductForm__AddToCart.sticky_add_atc_btn')){
        document.querySelector('.Product__Info  .ProductForm__BuyButtons .ProductForm__AddToCart').classList.remove('sticky_add_atc_btn');
        if(window.screen.width < 768){  
        window.scroll({
          top: document.querySelector('.ProductForm__BuyButtons').offsetTop, 
          left: 0, 
          behavior: 'smooth' 
        });
      }
      }
      var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = 'The maximum quantity of this item is already in your cart.';
        document.querySelector('.ProductForm__AddToCart').insertAdjacentElement('afterend', errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
    }
    

//     if($this.parents('.upsell-btn').length > 0) {

//     var qty = parseInt($('.qty-input').val());
//     var alreadyInCart = $('.cart-item[data-id="' + productId + '"]').length > 0;

//     if (!(qty == 1 && alreadyInCart)) {
//         $('.cus-membership').hide();
//         $('.icon-text-image').hide();
//          $('.ambassador_text').show();
//         $('.pop-up-text').hide();
//     }
// }
$('.ProductForm__AddToCart').removeAttr('disabled')
   if(document.querySelector('.sticky-add-to-cart .atc_btn')){
            document.querySelector('.sticky-add-to-cart .atc_btn').removeAttribute('disabled');
          }


    $this.removeAttr("disabled");
  })
  .catch((error) => {
    $('.ProductForm__AddToCart').removeAttr('disabled')
    $this.removeAttr("disabled");
  });
});


$(document).on("click", ".Product__SlideItem", function () {

    var clickedItem = $(this);
    var container = clickedItem.parent();

    container.prepend(clickedItem);

});



 class Currency {

  static formatMoney(cents, format = window.theme.moneyFormat || '${{amount}}') {

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    let value = '';
    const formatString = format;

    switch (formatString.match(placeholderRegex)[1]) {

      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;

      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;

      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }
}


document.querySelectorAll('input[name="fbt_products[]"]').forEach(cb => {
  cb.addEventListener('change', function() {
    var total_price = 0;
    var total_com_price = 0;
    document.querySelectorAll('.fbt-grid input:checked').forEach(function(e, i){
      var current_price = parseInt(e.closest('.fbt-item').querySelector('.price').getAttribute('data-price'));
      total_price = total_price + current_price;
    })
    document.querySelectorAll('.fbt-grid input:checked').forEach(function(e, i){
      var current_com_price = parseInt(e.closest('.fbt-item').querySelector('.cmp_price').getAttribute('data-com-price'));
      total_com_price = total_com_price + current_com_price;
    })

    document.querySelector('.claim_btn .price').innerHTML = Currency.formatMoney(total_price);
    document.querySelector('.claim_btn .com-price').innerHTML = Currency.formatMoney(total_com_price);
  });
});


document.querySelector('.claim_btn .btn_inner').addEventListener('click', function() {
  var total_item = [];
  document.querySelectorAll('.fbt-grid input:checked').forEach(function(e, i){
    total_item.push({"quantity": 1,"id": e.value});
  })

 this.setAttribute('disabled','disabled');
    
          
  if(total_item.length != 0){
    let add_free_product = {
      "items": total_item
    }
    var currunt_btn = this;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: add_free_product,
      dataType: 'json',
      success: function(success) {
        currunt_btn.removeAttribute('disabled');
        // window.location.href = '/cart';
        document.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: {
                        variant: success
                    }
                }));
      },
      error: function (error) {      
        console.log('error :' ,error.responseJSON['description']);
      }
    });
  }

   
});